<template>

  <div class="OrderDetail">
    <div class="main">
      <div class="div-container">
        <div class="col_1"></div>
        <div class="col_2"><h1 id="title">{{dynamicTitle('orderDetail')}}</h1> </div>
        <div class="col_3" v-if="order">
          <router-link v-if="$parent.isPhone" class="editOrderButton" id="editOrderButtonMobile" :to="{ name: 'UpdateOrder', params: {id: order.id}}"><i class="icon-pencil"></i></router-link>
          <router-link v-else class="editOrderButton" id="editOrderButtonWeb" :to="{ name: 'UpdateOrder', params: {id: order.id}}"><i class="icon-pencil"></i>{{dynamicTitle('editDetail')}}</router-link>
        </div>
      </div>

      <div class='order' v-if='order != null'>

        <div id="companyName" v-if="company != null && company.name">{{company.name}}</div>

        <div id="orderId">{{dynamicTitle('orderId')}}:    {{order.id}}</div>

        <table v-if="order != null" >
          <tbody>
          <tr id="orderCustomerRow">
            <td class="tableItemName">{{dynamicTitle('clientName')}}:</td>
            <td class="tableItemValue" v-if="order.client">{{order.client}}様</td>
          </tr>
          <tr id="destinationAddressRow" v-if="order.destination != null && order.destination.address != null">
            <td class="tableItemName">{{dynamicTitle('destinationAddress')}}:</td>
            <td class="tableItemValue"> {{ order.destination.address }}</td>
          </tr>
          <tr id="destinationPositionRow" v-if="order.destination_latitude != null && order.destination_longitude != null">
            <td class="tableItemName"></td>
            <td class="tableItemValue">{{ order.destination_latitude }}, {{order.destination_longitude}}</td>
          </tr>
          <tr id="destinationNameRow" v-if="order.destination_name != null">
            <td class="tableItemName">{{dynamicTitle('destinationName')}}:</td>
            <td class="tableItemValue"> {{ order.destination_name }}</td>
          </tr>
          <tr id="orderNameRow" v-if="order.name != null && order.name != ''"> <!-- (EditOrder機能) の影響で変更: nullと(今回は、空も含めて）場合も非表示 -->
            <td class="tableItemName">{{dynamicTitle('orderName')}}:</td>
            <td class="tableItemValue">{{ order.name }}{{dynamicTitle('orderNamePostfix')}}</td>
          </tr>

          <tr id="driverNameRow" v-if="driver != null && driver.name != null">
            <td class="tableItemName">ドライバー:</td>
            <td class="tableItemValue">{{ driver.name }}</td>
          </tr>
          </tbody>
        </table>


        <div  id="mapTitle">▼{{dynamicTitle('visibleWhileDelivering')}}</div>




        <gmap-map
          id="map"
          ref="map"
          :center="{lat: center.latitude, lng: center.longitude}"
          :zoom="15"
        >
          <gmap-marker
            :key="index"
            v-for="(m, index) in markers"
            :position="{lat: m.latitude, lng: m.longitude}"
            :icon="{ url: require('../assets/driver_pin.png'),
            scaledSize: {width: 34, height: 40}}"
          ></gmap-marker>

          <gmap-marker
            :key="index + 1000"
            v-for="(m, index) in destinations"
            :position="{lat: m.latitude, lng: m.longitude}"
          ></gmap-marker>
        </gmap-map>
      </div>
    </div>
  </div>

</template>

<script>
  import {db, fb} from '../firebase'
  import moment from 'moment'
  import axios from 'axios';
  import {Subject, Observable, combineLatest, asyncScheduler, asapScheduler} from 'rxjs'



  const words = {
    'dayservice' : {
      'orderDetail' : '送迎の詳細',
      'orderId' : '送迎ID',
      'clientName' : 'ご契約者様',
      'destinationAddress' : '送迎先住所',
      'destinationName' : '送迎先お客様',
      'orderName' : 'ご利用者様',
      'orderNamePostfix' : '様',
      'visibleWhileDelivering' : '送迎先の位置 ( この利用者様の送迎を開始したらドライバーの現在地も表示されます )',
    },
    'bike' : {
      'orderDetail' : '注文の詳細',
      'orderId' : '注文ID',
      'clientName' : 'ご依頼主',
      'destinationAddress' : '配達先住所',
      'destinationName' : '配達先お客様名',
      'orderName' : 'お届け物',
      'orderNamePostfix' : '',
      'visibleWhileDelivering' : '配達先の位置 ( この注文の配達を開始したらドライバーの現在地も表示されます )',
    },
    'default' : {
      'orderDetail' : '詳細',
      'editDetail' : '注文を編集する',
      'orderId' : 'ID',
      'clientName' : 'ご依頼主',
      'destinationAddress' : '住所',
      'destinationName' : '送迎先のごお客様名、あるいは配達先のお客様名',
      'orderName' : '送迎のご利用者様、あるいは配達のお届け物',
      'orderNamePostfix' : '',
      'visibleWhileDelivering' : '送迎先・配達先の位置 ( ドライバーがむかっているときだけ現在地が表示されます )',
    }
  }

  export default {

    name: "OrderDetail",
    created () {

      var _this = this
      this.driverFetchSubject = new Subject()
      this.destinationFetchSubject = new Subject()
      this.mapLoadSubject = new Subject()

      this.$watch('driver', function(value) {
        console.log('driver changed, and position updated')

        //console.log('driver position is', value.position)

        //送迎状態のときのみ位置を表示
        if(this.order.status === "started"){

          if (value.latitude && value.longitude) {
            _this.markers = []
            _this.markers.push({
              latitude: value.latitude,
              longitude: value.longitude
            })

          }
        }else{
          _this.markers = []
        }
      })

      this.$watch('order', function (value) {

        if (value.destination_latitude && value.destination_longitude) {

          _this.destinations = []
          _this.destinations.push({
            latitude: value.destination_latitude,
            longitude: value.destination_longitude
          })

          console.log('order changed, and position updated', _this.destinations)

        }



      })
    },
    mounted () {
      console.log('mounted')

      if(!this.companyId){
        this.$router.push('/signin')
      }else{
        this.geolocate();
        this.getOrder()
        this.getCompany()
      }

      var _this = this

      this.$nextTick(function () {
        /* マップオブジェクトを取得(mountedでやると、まだthis.$refs.mapがnull */
        setTimeout(function() {
          if(_this.$refs.map != null){
            _this.$refs.map.$mapPromise.then((map) => {
              console.log('map is not null')


              if(_this.markers.length > 0 && _this.destinations.length > 0){
                let bounds  = new google.maps.LatLngBounds();
                let locDriver = new google.maps.LatLng(_this.markers[0].latitude, _this.markers[0].longitude);
                bounds.extend(locDriver);
                let locDestination = new google.maps.LatLng(_this.destinations[0].destination_latitude, _this.destinations[0].destination_longitude);
                bounds.extend(locDestination);

                if(_this.isAutoZoomDoneOnce === false){
                  console.log('auto zoom (first time)', bounds)
                  map.fitBounds(bounds);       //auto-zoom
                  map.panToBounds(bounds);       // auto-center

                  _this.isAutoZoomDoneOnce = true
                }else if(map.getBounds().contains(locDriver) === false){
                  console.log('auto zoom c/z driver is out of the map bounds', bounds)
                  map.fitBounds(bounds);       //auto-zoom
                  map.panToBounds(bounds);       // auto-center
                }
              }else{
                console.log('either destination or driver position not available')
                if(_this.destinations.length > 0){
                  _this.center = {
                    latitude: _this.destinations[0].latitude,
                    longitude: _this.destinations[0].longitude
                  }
                  console.log('move to destination', _this.center)


                }else if(_this.markers.length > 0){
                  _this.center = {
                    latitude: _this.markers[0].latitude,
                    longitude: _this.markers[0].longitude
                  }
                  console.log('move to driver', _this.center)
                }
              }

              _this.mapLoadSubject.next()
            })
          }else{
            console.log('map is null')
          }
        }, 250);

      })

      this.subscription = combineLatest(this.driverFetchSubject, this.destinationFetchSubject, this.mapLoadSubject).subscribe(
        () => {
          console.log('combineLatest')

          if(!_this.isDirectionLoaded ){
            _this.getDirections()
          }
        }
      );
    },

    data () {
      return {
        order: null,
        driver: null,
        company: null,
        //position: null,
        devMes: null,

        center: { latitude: 45.508, longitude: -73.587 },
        latLng: { lat: 45.508, lng: -73.587 },
        markers: [],
        destinations: [],

        isAutoZoomDoneOnce: false,

        driverFetchSubject: null,
        destinationFetchSubject: null,
        mapLoadSubject: null,
        subscription: null,
        isDirectionLoaded: false
      }
    },

    props: {
      zoom: {
        type: Number,
        default: 16
      },

    },

    computed: {

      trackingDatetime: function () {
        self = this;
        return function (order) {
          let tracking = order['tracking']
          if(tracking != null){
            let date = tracking['datetime'].toDate()
            return moment(date).format('HH:mm, YYYY/MM/DD')
          }
          return ""
        };
      },

      companyId() {
        let coId = this.$store.getters.companyId
        if(coId){
          return coId
        }

        //localStorageに存在したらそれをVuexのstoreに書き込んでリターンする。
        if (localStorage.companyId) {
          this.$store.commit('setCompanyId', localStorage.companyId)
          return localStorage.companyId
        }
      }

      /*
      datetime() {
        return order => order['tracking']['datetime'].toDate() | moment
      }
      */
    },

    methods: {

      // receives a place object via the autocomplete component
      setPlace(place) {

      },


      getOrder () {
        var _this = this

        this.$bind('order', db.collection('companies').doc(this.companyId).collection('orders').doc(this.$route.params.id)).then(order => {

          this.destinationFetchSubject.next()

          if (_this.company == null) {
            console.log("getCompany");
            _this.getCompany()
          }

          if (_this.driver == null) {
            _this.getDriver()
          }

          //_this.registerToken()
        })


      },
      getDriver () {
        this.$bind('driver', db.collection('companies').doc(this.companyId).collection('drivers').doc(this.order.driver_id)).then(driver => {
          //this.$unbind('driver')

          this.driverFetchSubject.next()
        })

      },

      getCompany () {
        this.$bind('company', db.collection('companies').doc(this.companyId)).then(company => {
          this.$unbind('company')
        })
      },

      geolocate: function() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
        });
      },

      /* ダイナミックタイトル */
      dynamicTitle(key){
        if(this.company){
          let type = this.company.type
          let wordSet = words[type]
          if(!wordSet){
            wordSet = words['default']
          }
          return wordSet[key]
        }
        return words['default'][key]
      },

      getDirections: function() {

        if(this.markers.length > 0 && this.destinations.length > 0){

          let start = {lat: this.markers[0].latitude, lng: this.markers[0].longitude}
          let destination = {lat: this.destinations[0].latitude, lng: this.destinations[0].longitude}

          var directionsService = new google.maps.DirectionsService;

          //https://stackoverflow.com/a/11510643/1709287
          var directionsDisplay = new google.maps.DirectionsRenderer(
            {
              suppressMarkers: true
            });
          directionsDisplay.setMap(this.$refs.map.$mapObject);

          //google maps API's direction service
          function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
            directionsService.route({
              origin: start,
              destination: destination,
              travelMode: 'DRIVING'
            }, function(response, status) {
              if (status === 'OK') {
                directionsDisplay.setDirections(response);
              } else {
                window.alert('Directions request failed due to ' + status);
              }
            });
          }

          console.log(start);
          console.log(destination);
          //console.log('hmmm yha');
          calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination);

          this.isDirectionLoaded = true
        }
      }
    }


  }
</script>

<style scoped>
  .OrderDetail{
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: #F3F3F3;
  }

  .OrderDetail h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin: 0 0 39px 0;
  }

  .main {
    width: 100%;
    background-color: #F3F3F3;
    padding-top: 58px;
  }

  h1, h2 {
    font-weight: normal;
  }
  a {
    color: #42b983;
  }

  .div-container {
    display: flex;
    margin: 0% 10%;
  }

  .col_1, .col_2, .col_3{
    width: 33.3%;
  }

  .editOrderButton{
    float: right;
    background-color: #D2FF00;
    color: #5C5C5C;
    border-radius: 11px;
    text-decoration: none;
    font-size: 15px;
    font-weight: normal;
    border: 2px solid Transparent; 
  }

  .editOrderButton:hover {
    border: 2px solid #C7D931;
  }

  .editOrderButton i {
    width: 15px;
    height: 15px;
    margin: 0 0 0 0;
  }

  #editOrderButtonWeb {
    padding: 4px 10px 4px 10px;
  }

  #editOrderButtonWeb i{
    margin-right: 10px;
  }

  #map {
    width: 100%;
    height: 800px;
  }

  .order {
    width: auto;
    height: 100%;
    text-align: center;
    margin-left: 10%;
    margin-right: 10%;
    background: white;
  }

  .order table {

    margin-left: auto;
    margin-right: auto;

    color: #5C5C5C;
    font-size: 14px;
    font-weight: lighter;

  }


  #companyName {
    color: #5C5C5C;
    font-size: 23px;
    font-weight: bold;
    padding-top: 26px;
  }

  #orderId{
    color: #5C5C5C;
    font-size: 14px;
    font-weight: lighter;
    margin-bottom: 30px;
  }

  #orderCustomerRow {

  }

  #orderName {

  }

  .tableItemName {
    text-align: right;
    padding-bottom: 10px;
  }

  .tableItemValue {
    text-align: left;
    padding-left: 20px;
    padding-bottom: 10px;
  }

  #destinationAddressRow .tableItemValue{
    padding-bottom: 0;
  }

  #destinationAddressRow .tableItemName{
    padding-bottom: 0;
  }

  #mapTitle {
    color: #5C5C5C;
    font-size: 18px;
    margin-top: 40px;
  }

  #destinationAddress {

  }

  #destinationPosition{

  }

  #driverName {

  }

  #driverPosition {

  }

  /* モバイル時の行 */
  #editOrderButtonMobile {
    margin: 1%;
    padding: 3px 15px 3px 15px;
  }

  /*mobile対応(iPad含む)*/
  @media(max-width: 768px) {

    .OrderDetail h1{
      font-size: 17px;
      font-weight: normal;
      margin: 0 0 0 0;
      height: 34px;
      line-height: 34px;
      padding-top: 4px;
    }

    .main {
      padding-top: 0;
    }

    .order {
      width: auto;
      height: 100%;
      text-align: center;
      margin-left: 2%;
      margin-right: 2%;
      background: white;
    }

    .order table {
      color: #5C5C5C;
      font-size: 14px;
      font-weight: lighter;
      margin-left: 7%;
      margin-right: 7%;
    }

    #companyName {
      font-size: 15px;
      padding-top: 10px;
      margin-bottom: 0;
    }

    #orderId{
      color: #5C5C5C;
      font-size: 10px;
      margin-top: 0;
      margin-bottom: 12px;
    }

    .tableItemName {
      text-align: right;
      vertical-align: top;
      padding-bottom: 2px;
      width: 80px;
    }

    .tableItemValue {
      text-align: left;
      padding-left: 20px;
      padding-bottom: 2px;
      vertical-align: top;
    }


    #mapTitle {
      color: #5C5C5C;
      font-size: 13px;
      margin-top: 20px;
      margin-bottom: 2px;
    }

    #map {
      width: 100%;
      height: 600px;
    }

    #editOrderButtonWeb {
      font-size: 10px;
      line-height: 28px;
    }

    .div-container {
      margin: 1% 2%;
    }


  }



</style>



// WEBPACK FOOTER //
// src/pages/OrderDetail.vue